const version = process.env.REACT_APP_BUILD_VERSION || '';
console.log('App Version: ', version);
console.log('Run with env: ', process.env.REACT_APP_ENVIRONMENT);

// React reads environment variables from .env.local
// by default when running npm start locally.
// You can add or update environment variables in .env.local,
// but you need to restart the app for the changes to take effect.
// All variables must start with the REACT_APP_ prefix.
// Reference link: https://create-react-app.dev/docs/adding-custom-environment-variables

const DOMAIN = process.env.REACT_APP_DOMAIN || '';
const CMS_URL = `https://${DOMAIN}`;
const AWS_CLOUDFRONT_DISTRIBUTION_DOMAIN = process.env.REACT_APP_CLOUDFRONT_URL || '';

export const env = {
  AXIOS_URL_DEV: 'http://localhost:4242/',
  AXIOS_URL: `https://${DOMAIN}/api`,
  CMS_URL: CMS_URL,
  MEDIA_URL: AWS_CLOUDFRONT_DISTRIBUTION_DOMAIN,
  IMAGE_URL: `${AWS_CLOUDFRONT_DISTRIBUTION_DOMAIN}/media`,
  REGION_URL: `https://${DOMAIN}/region`,
};
